import axios from "axios";

const prepareData = (data) => {return {project_twr_category:data}}

// Plural Actions
export const GET_PROJECT_TWR_CATEGORIES = "get_project_twr_categories";
export const getProjectTwrCategories = () => {
	const url = `/project/twr/categories.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_TWR_CATEGORIES,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_TWR_CATEGORY = "create_project_twr_category";
export const createProjectTwrCategory = (data) => {
	const url = `/project/twr/categories.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_TWR_CATEGORY,
		payload: request
	};
};

export const GET_PROJECT_TWR_CATEGORY = "get_project_twr_category";
export const getProjectTwrCategory = (id) => {
	const url = `/project/twr/categories/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_TWR_CATEGORY,
		payload: request
	};
};

export const UPDATE_PROJECT_TWR_CATEGORY = "update_project_twr_category";
export const updateProjectTwrCategory = (id,data) => {
	const url = `/project/twr/categories/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_TWR_CATEGORY,
		payload: request
	};
};

export const DESTROY_PROJECT_TWR_CATEGORY = "destroy_project_twr_category";
export const destroyProjectTwrCategory = (id) => {
	const url = `/project/twr/categories/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_TWR_CATEGORY,
		payload: request
	};
};
